export default __webpack_public_path__ + "static/media/lastStandStory.94c7eaef.mp3";